export default "__VITE_ASSET__CHXNC_xy__"